import { render, staticRenderFns } from "./JsonChildListSetterButton.vue?vue&type=template&id=5736f8ec&"
import script from "./JsonChildListSetterButton.vue?vue&type=script&lang=js&"
export * from "./JsonChildListSetterButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports